import React, { useEffect, useState } from 'react';
import { popupOpenService } from '../../shared/popupOpenService';
import { POPUP_KEY_DELETE_PREFERENCE } from '../../constant';
import { TrashIcon } from '../../appearence/icons/trash_icon';
import { preferencesStorageInstance as preferencesStorage } from '../../services/preferencesStorage';
import {IconWrapper} from "../../appearence/icons/icon_wrapper";

const PreferencesListActionsDeleteIcon = () => {
    const [isDisabled, setIsDisabled] = useState(true);
    const deletePreference = () => {
        if(!isDisabled) {
            popupOpenService.callToOpen(POPUP_KEY_DELETE_PREFERENCE);
        }
    };

    const changeIsDisabled = () => {
        setIsDisabled(preferencesStorage.getSelectedPreferencesList().length === 0);
    };

    useEffect(() => {
        preferencesStorage.registerFiltersChangingObserver(changeIsDisabled);
        return () => preferencesStorage.unRegisterFiltersChangingObserver(changeIsDisabled);
    }, []);

    return (
        <li onClick={deletePreference}>
            <IconWrapper><TrashIcon/></IconWrapper>
        </li>
    );
};

export default PreferencesListActionsDeleteIcon;
